// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"81":"12428397","326":"12428397","679":"12428397","926":"12428397"}[chunkId] + ".chunk.css";
};